import React from 'react';

const FeatureCard = ({ feature, index }) => {
  // Definir imágenes de fondo tecnológicas y profesionales
  const backgroundImages = [
    'https://images.unsplash.com/photo-1518709268805-4e9042af2176?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80', // Tech abstract
    'https://images.unsplash.com/photo-1451187580459-43490279c0fa?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80', // Network/connectivity
    'https://images.unsplash.com/photo-1560472354-b33ff0c44a43?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80', // Business/consulting
    'https://images.unsplash.com/photo-1558494949-ef010cbdcc31?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80', // Innovation
    'https://images.unsplash.com/photo-1573164713714-d95e436ab8d6?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80', // Professional
    'https://images.unsplash.com/photo-1504384308090-c894fdcc538d?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'  // Modern office
  ];

  const backgroundImage = backgroundImages[index % backgroundImages.length];

  return (
    <div 
      className="relative bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2 group"
      style={{ 
        minHeight: '420px'
      }}
    >
      {/* Imagen de fondo con overlay */}
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url(${backgroundImage})`
        }}
      >
        {/* Overlay negro con opacidad */}
        <div className="absolute inset-0 bg-black bg-opacity-60 group-hover:bg-opacity-70 transition-all duration-500"></div>
        
        {/* Overlay azul en hover */}
        <div className="absolute inset-0 bg-blue-600 bg-opacity-0 group-hover:bg-opacity-20 transition-all duration-500"></div>
      </div>
      
      {/* Contenido */}
      <div className="relative z-10 p-8 h-full flex flex-col justify-between">
        <div>
          {/* Icono */}
          <div className="mb-6">
            <div className="w-16 h-16 bg-white bg-opacity-10 backdrop-filter backdrop-blur-sm rounded-xl flex items-center justify-center border border-white border-opacity-20">
              <i className={`${feature.icon} text-2xl text-white`}></i>
            </div>
          </div>

          {/* Título */}
          <h3 className="text-2xl font-bold text-white mb-4 leading-tight group-hover:text-blue-100 transition-colors duration-300">
            {feature.title}
          </h3>
          
          {/* Descripción */}
          <p className="text-gray-200 leading-relaxed text-base group-hover:text-gray-100 transition-colors duration-300">
            {feature.description}
          </p>
        </div>
        
        {/* Botón de acción */}
        <div className="mt-8">
          <div className="flex items-center text-white group-hover:text-blue-200 transition-colors duration-300">
            <span className="text-sm font-semibold mr-2">Ver más</span>
            <div className="w-8 h-8 bg-blue-500 rounded-full flex items-center justify-center group-hover:bg-blue-400 transition-colors duration-300 group-hover:translate-x-1 transform">
              <i className="fas fa-arrow-right text-xs"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FeatureCard;